import { render, staticRenderFns } from "./AdminUsers.vue?vue&type=template&id=61a84dfa&scoped=true"
import script from "./AdminUsers.vue?vue&type=script&lang=js"
export * from "./AdminUsers.vue?vue&type=script&lang=js"
import style0 from "./AdminUsers.vue?vue&type=style&index=0&id=61a84dfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61a84dfa",
  null
  
)

export default component.exports